import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { useAccounts } from '../../context/AccountContext';

export default function Followers() {
  const { scopeParams, accounts } = useAccounts();
  const multiAccount = accounts.length > 1;
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [msg, setMsg]             = useState('');

  useEffect(() => {
    setLoading(true);
    api.get('/trader/followers', { params: scopeParams })
      .then(r => setFollowers(r.data)).finally(() => setLoading(false));
  }, [scopeParams]);

  async function block(copierId) {
    if (!window.confirm(
      'Block this copier?\n\nThey will stop copying every one of your MT5 accounts '
      + 'and cannot follow you again — from any of their accounts — until you unblock them.'
    )) return;
    try {
      await api.delete(`/trader/followers/${copierId}`);
      setMsg('Copier blocked — they can no longer copy any of your accounts.');
      setFollowers(prev => prev.map(f => f.copier?._id === copierId
        ? { ...f, status: 'stopped', blockedByTrader: true, copierBlocked: true } : f));
    } catch (e) {
      setMsg('Error: ' + e.response?.data?.error);
    }
  }

  async function unblock(copierId) {
    try {
      await api.put(`/trader/followers/${copierId}/unblock`);
      setMsg('Copier unblocked. They can follow you again.');
      setFollowers(prev => prev.map(f => f.copier?._id === copierId
        ? { ...f, blockedByTrader: false, copierBlocked: false } : f));
    } catch (e) {
      setMsg('Error: ' + e.response?.data?.error);
    }
  }

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">My Followers ({followers.length})</h5>
          </div>
          <div className="card-body">
            {msg && <div className="alert alert-info">{msg}</div>}
            {loading ? <p className="text-muted">Loading...</p> : (
              followers.length === 0 ? <p className="text-muted">No followers yet.</p> : (
                <div className="table-responsive table-cards table-cards-wrap">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Copier</th>
                        {multiAccount && <th>Following</th>}
                        <th>Scaling Mode</th>
                        <th className="num">Risk Multiplier</th>
                        <th className="num">Copier Equity</th>
                        <th className="num">Copied Trades</th>
                        <th className="num">Total P&L</th>
                        <th>Status</th>
                        <th>Since</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {followers.map(f => (
                        <tr key={f.id}>
                          <td data-label="Copier">{f.copier?.username || f.copier?.email}</td>
                          {multiAccount && (
                            <td data-label="Following" className="small">
                              {f.traderAccountLabel || '—'}
                            </td>
                          )}
                          <td data-label="Scaling Mode"><span className="badge badge-info">{f.scalingMode}</span></td>
                          <td data-label="Risk Multiplier" className="num">{f.riskMultiplier}x</td>
                          <td data-label="Copier Equity" className="num">${f.copierEquity?.toFixed(2) || '—'}</td>
                          <td data-label="Copied Trades" className="num">{f.totalCopiedTrades}</td>
                          <td data-label="Total P&L" className={`num ${f.totalPnl >= 0 ? 'text-success' : 'text-danger'}`}>
                            {f.totalPnl >= 0 ? '+' : ''}{f.totalPnl?.toFixed(2)}
                          </td>
                          <td data-label="Status">
                            {(f.copierBlocked || f.blockedByTrader)
                              ? <span className="badge badge-danger">blocked</span>
                              : <span className={`badge badge-${f.status === 'active' ? 'success' : 'secondary'}`}>{f.status}</span>}
                          </td>
                          <td data-label="Since" className="text-muted small">{new Date(f.createdAt).toLocaleDateString()}</td>
                          <td data-label="Actions">
                            {(f.copierBlocked || f.blockedByTrader)
                              ? <button className="btn btn-secondary btn-sm" onClick={() => unblock(f.copier?._id)}>Unblock</button>
                              : <button className="btn btn-danger btn-sm" onClick={() => block(f.copier?._id)}>Block</button>}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
